/*
 * @Description: 
 * @Author: kai.zhou
 * @Date: 2020-11-13 21:14:19
 * @LastEditors: kai.zhou
 * @LastEditTime: 2021-04-25 20:36:44
 */
export default {
  lang: "法语",
  landing: {
    name1: "Ouvrir l'application Carlcare",
    name2: "Faire une réservation",
    name3: "Utilisez l'application Carlcare, vous pouvez vérifier ",
    name4: "les informations de la commande à tout moment!",
  },
};